import SectionFormContact from "../sections/contacto/section-form-contact/SectionFormContact";
import SectionMediosContact from "../sections/contacto/section-medios-contact/SectionMediosContact";
// import SectionDownDoc from "../sections/contacto/section-down-doc/SectionDownDoc";
const Contacto = () => {
  return (
    <>
      <SectionFormContact />
      <SectionMediosContact />
      {/* <SectionDownDoc /> */}
    </>
  );
};
export default Contacto;
